import { mapActions, mapGetters } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('dashboard/appointments', [
      'appointmentsKey',
      'getAppointmentsMetaByBucketName',
      'getRawAppointmentsByBucketName',
      'getGroupedByDateRawAppointmentsByBucketName',
    ]),
    meta () {
      return this.getAppointmentsMetaByBucketName(
        this.appointmentsBucketName,
        this.appointmentsKey
      );
    },
    rawAppointments () {
      return this.getRawAppointmentsByBucketName(this.appointmentsBucketName, this.appointmentsKey);
    },
    groupedByDateRawAppointments () {
      return this.getGroupedByDateRawAppointmentsByBucketName(
        this.appointmentsBucketName,
        this.appointmentsKey
      );
    },
  },
  methods: {
    ...mapActions('dashboard/appointments', [
      'fetchAppointments',
      'fetchAppointmentsByDate',
      'resetAppointments',
    ]),
  },
};
